import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import Tabs from 'components/Tabs/Tabs'

import ROUTES from 'constants/routes'

import PlansTab from './Tabs/Plans/Plans'
import CurrenciesTab from './Tabs/Currencies/Currencies'

import styles from './Products.module.scss'

class Products extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const { currencies } = this.state

        return (
            <>
                <Tabs
                    isVisibleBottomLine={false}
                    list={[
                        {
                            to: `${ROUTES.PRODUCTS.path}/plans`,
                            label: 'Plans',
                        },
                        {
                            to: `${ROUTES.PRODUCTS.path}/currencies`,
                            label: 'Currencies',
                        },
                    ]}
                />

                <div className={styles.products}></div>

                <br />
                <br />

                <Switch>
                    <Route
                        exact
                        path={`${ROUTES.PRODUCTS.path}/plans`}
                        render={() => <PlansTab location={this.props.location} history={this.props.history} />}
                    />
                    <Route
                        exact
                        path={`${ROUTES.PRODUCTS.path}/currencies`}
                        render={() => <CurrenciesTab location={this.props.location} history={this.props.history} />}
                    />
                    <Redirect
                        from="*"
                        to={{
                            pathname: ROUTES.ERROR.path,
                            state: {
                                errorCode: 404,
                            },
                        }}
                    />
                </Switch>
            </>
        )
    }
}

export default Products
